/**
 * InputGate
 * ---------
 * Decides whether the customer is allowed to type into the chat box.
 *
 * The conversation is button-driven: an AWB, mobile number or any other free
 * text typed on a menu screen used to be re-routed by digit count and could
 * restart the session in the middle of a flow. Typing is therefore accepted
 * only on the steps that ask for it.
 */

/**
 * @param {object} context
 * @param {boolean} context.isDateOnlyStep      Dates come from buttons only.
 * @param {boolean} context.isOtpEntryStep      OTP sent and not yet validated.
 * @param {boolean} context.botAwaitingSelection Last bot message was a menu.
 * @param {boolean} context.stepExpectsFreeText  Pincode / address / alternate
 *                                               mobile / incident description.
 * @param {boolean} context.isIdentifierEntryStep Awaiting AWB or mobile number.
 */
export const isFreeTextInputExpected = (context = {}) => {
  const {
    isDateOnlyStep = false,
    isOtpEntryStep = false,
    botAwaitingSelection = false,
    stepExpectsFreeText = false,
    isIdentifierEntryStep = false,
  } = context;

  if (isDateOnlyStep) {
    return false;
  }
  // An OTP prompt can arrive inside a Mongo "buttons" envelope, so it must win
  // over the menu check below.
  if (isOtpEntryStep) {
    return true;
  }
  if (botAwaitingSelection) {
    return false;
  }
  return Boolean(stepExpectsFreeText || isIdentifierEntryStep);
};
